import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { PollData } from '../../providers/poll';
import { Utilities } from '../../providers/utilities';

@Pipe({
  name: 'pollAnswers',
})
export class PollAnswersPipe implements PipeTransform {

  constructor(
    private pollData: PollData,
    private utilities: Utilities
  ) { }

  transform(pollId: string, clientId: string, eventId: string): Observable<any> {
    if (this.utilities.validateEventIdParam(eventId)) {
      return this.pollData.getPollEventAnswers(clientId, eventId, pollId);
    } else {
      return this.pollData.getPollAnswers(clientId, pollId);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/poll/poll-answer.ts